// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 9673) return "static/chunks/9673-429e1c7436ceac40.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"130":"3151d13ef0fd57b5","534":"c54da9be465b435e","538":"7dc18fffeb7a4f20","2526":"a45e40b83225f869","6752":"a4aa69aecd43b02d","8361":"833194b7817dcebd","9417":"7d51974a2b297c09"}[chunkId] + ".js";
};